<!-- DESKTOP SIDEBAR -->
<div *ngIf="!hideSideBarMenu" class="main-side-bar mobile-hidden">
    <!-- LATERAL NAVBAR -->
    <div class="main-side-bar-view buttons">
        <!-- PROFILE PIC -->
        <div class="top">
            <ng-container *ngIf="!isStandAlone()">
                <div class="pic" *ngIf="showSB" (click)="toggleProfile()">
                    <img src="assets/dsm/01-atm/avatars/avatar-default.svg" alt="Avatar">
                </div>
                <div 
                    *ngIf="showSB"
                    id="download"
                    class="downloads" 
                    [ngClass]="{ 'downloads--active': downloadOpened }"
                    (click)="toggleDownload();">
                </div>
                <div id="notification-bell" class="bell" (click)="notificationBellClick()"
                    [ngClass]="{'bell-animation': hasUnseenNotifications}">
                    <span *ngIf="hasUnseenNotifications" class="unread"></span>
                    <sc-icon icon="bell" size="1_25"></sc-icon>
                </div>
            </ng-container>
        </div>
        <!-- HELP AND COMPANY LOGO -->
        <div class="bottom">
            <div class="help">
                <a id="ayuda" class="ayuda" (click)="openFaq();"><span class="icon-question-elipse"></span></a>
            </div>
            <div class="logo">
                <a [routerLink]="['/inicio']" id="logo" class="logo-icon link" (click)="closeNotification()"></a>
            </div>
        </div>
    </div>
    <!-- PROFILE -->
    <div class="main-side-bar-view profile" *ngIf="showSB" [ngClass]="profileOpened?'opened':'closed'">
        <div class="index" [ngClass]="profileOpened ? 'opened' : 'closed'">
            <!-- PROFILE TITLE -->
            <div class="profile-title">
                <span>Mi cuenta</span>
                <div class="profile-close btn-close" (click)="toggleProfile()">
                    <span class="close-button icon-close-elipse"></span>
                </div>
            </div>
            <div *ngIf="user" class="profile-user">
                <span>{{user.lastName | uppercase}} {{user.firstName | titlecase}}</span>
            </div>
            <!-- PROFILE ITEMS -->
            <ul *ngIf="sbData">
                <li *ngFor="let p of profileItems; let kp = index;" [class.active]="p.selected">
                    <div (click)="goTo(p,1,kp)" id="{{p.sidebar_id}}">
                        <span>{{p.text | truncate:maxLabelLength}}</span>
                        <span class="arrow icon-arrow-right" *ngIf="p.items&& p.items.length && !p.selected"></span>
                        <span class="arrow icon-arrow-down" *ngIf="p.items&& p.items.length && p.selected"></span>
                    </div>
                    <ul *ngIf="(p.items&& p.items.length && (p.id !=='siniestros' || (p.id !=='siniestros' && claimLink)))"
                        [ngClass]="{expand:p.selected,shrink:!p.selected}">
                        <li *ngFor="let i of p.items; let ki = index;" (click)="goTo(i,1,kp,ki)"
                            [class.active]="i.selected"
                            id="{{i.sidebar_id}}">
                            <div>
                                <span>{{i.text}}</span>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
            <!-- PROFILE LOGOUT -->
            <div class="logOut" (click)="logOut()">
                <span>Cerrar sesión</span>
            </div>
        </div>
    </div>
    <!-- DOWNLOAD -->
    <div class="main-side-bar-view download" *ngIf="showSB" [ngClass]="downloadOpened?'opened':'closed'">
        <div class="index" [ngClass]="downloadOpened ? 'opened' : 'closed'">
            <!-- DOWNLOAD TITLE -->
            <div class="download-title">
                <span>Info y descargas</span>
                <div class="download-close btn-close" (click)="toggleDownload()">
                    <span class="close-button icon-close-elipse"></span>
                </div>
            </div>
            <!-- DOWNLOAD ITEMS -->
            <ul *ngIf="sbData">
                <li *ngFor="let p of downloadsItems; let kp = index;" [class.active]="p.selected">
                    <div (click)="goTo(p,2,kp)" id="{{p.sidebar_id}}">
                        <span>{{p.text}}</span>
                        <span class="arrow icon-arrow-right" *ngIf="p.items&& p.items.length && !p.selected"></span>
                        <span class="arrow icon-arrow-down" *ngIf="p.items&& p.items.length && p.selected"></span>
                    </div>
                    <ul *ngIf="(p.items&& p.items.length && (p.id !=='siniestros' || (p.id !=='siniestros' && claimLink)))"
                        [ngClass]="{expand:p.selected,shrink:!p.selected}">
                        <li *ngFor="let i of p.items; let ki = index;" (click)="goTo(i,2,kp,ki)"
                            [class.active]="i.selected"
                            id="{{i.sidebar_id}}">
                            <div><span>{{i.text}}</span></div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
    <!-- MENU -->
    <div class="main-side-bar-view main-side-bar-menu sc-scroll-bar-light" *ngIf="showSB">
        <div class="index">
            <!-- User box is forced to hide because of US 10430 -->
            <div *ngIf="false" class="user-box">
                <div class="user mobile-hidden" *ngIf="showSB">
                    <div class="user-name">
                        {{authService.user && authService.user.userName && authService.user.userName.toUpperCase() }}
                    </div>
                    <div class="user-info">
                        {{authService.user && authService.user.sub}}
                    </div>
                </div>
            </div>
            <!-- MENU ITEMS -->
            <ul *ngIf="sbData">
                <ng-container *ngFor="let p of sideBarItems; let kp = index;">
                    <li *ngIf="(p.origin ==='CLAIM' && claimLink) || (p.origin !=='CLAIM')" [class.active]="p.selected && !p.items"
                        [class.expanded]="p.selected && p.items">
                        <div (click)="goTo(p,0,kp)" id="{{p.sidebar_id}}">
                            <span>{{p.text}}</span>
                            <span class="arrow icon-arrow-right" *ngIf="p.items&& p.items.length && !p.selected"></span>
                            <span class="arrow icon-arrow-down" *ngIf="p.items&& p.items.length && p.selected"></span>
                        </div>
                        <ul *ngIf="(p.items&& p.items.length)" [ngClass]="{expand:p.selected,shrink:!p.selected}">
                            <ng-container *ngFor="let i of p.items; let ki = index;">
                                <li (click)="goTo(i,0,kp,ki)" [class.active]="i.selected"
                                    id="{{i.sidebar_id}}">
                                    <div><span class="d-block">{{i.text}}</span></div>
                                </li>
                            </ng-container>
                        </ul>
                    </li>
                </ng-container>
            </ul>
        </div>
    </div>
</div>



<!-- MOBILE SIDEBAR -->
<div *ngIf="!hideSideBarMenu" class="main-side-bar desktop-hidden" [ngClass]="state || 'closed'">
    <!-- NAVBAR -->
    <div class="main-side-bar-view buttons">
        <!-- NAVBAR CLOSE BUTTON -->
        <div class="left">
            <div class="pic" (click)="toggleMenu()">
                <span class="sc-icon icon-burger-menu" *ngIf="!menuOpened"></span>
                <span class="sc-icon icon-close-elipse" *ngIf="menuOpened"></span>
            </div>
        </div>
        <!-- NAVBAR COMPANY LOGO -->
        <div class="center">
            <img src="assets/images/logo-160-x-64.svg" alt="logo">
        </div>
        <!-- NAVBAR HELP -->
        <div class="right">
            <div id="notification-bell-mobile" class="bell" (click)="notificationBellClick()"
                [ngClass]="{'bell-animation': hasUnseenNotifications}">
                <span *ngIf="hasUnseenNotifications" class="unread"></span>
                <sc-icon icon="bell" size="1_25"></sc-icon>
            </div>
        </div>
    </div>
    <!-- PROFILE -->
    <div class="main-side-bar-view profile" [ngClass]="profileOpened?'opened':'closed'">
        <div class="index" [ngClass]="profileOpened ? 'opened' : 'closed'">
            <!-- OPEN PROFILE HEADER -->
            <div class="header" (click)="toggleProfile(true)">
                <div class="profile-title">
                    <img src="assets/dsm/01-single-elements/icons/arrow-left.svg" alt="flecha izquierda">
                    <span>Mi cuenta</span>
                    <div class="profile-close">
                        <span class="close-button icon-close-elipse"></span>
                    </div>
                </div>
                <div class="clearfix dark"></div>
            </div>
            <!-- OPEN PROFILE ITEMS -->
            <div class="profile-body sc-scroll-bar">
                <ul *ngIf="sbData">
                    <li *ngFor="let p of profileItems; let kp = index;" [class.active]="p.selected">
                        <div (click)="goTo(p,1,kp)" id="{{p.sidebar_id}}">
                            <span>{{p.text | truncate:maxLabelLength}}</span>
                            <span class="arrow icon-arrow-right" *ngIf="p.items&& p.items.length && !p.selected"></span>
                            <span class="arrow icon-arrow-down" *ngIf="p.items&& p.items.length && p.selected"></span>
                        </div>
                        <ul *ngIf="(p.items&& p.items.length && (p.id !=='siniestros' || (p.id !=='siniestros' && claimLink)))"
                            [ngClass]="{expand:p.selected,shrink:!p.selected}">
                            <li *ngFor="let i of p.items; let ki = index;" (click)="goTo(i,1,kp,ki)"
                                [class.active]="i.selected"
                                id="{{i.sidebar_id}}">
                                <div>
                                    <span>{{i.text}}</span>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- DOWNLOAD -->
    <div class="main-side-bar-view download" [ngClass]="downloadOpened?'opened':'closed'">
        <div class="index" [ngClass]="downloadOpened ? 'opened' : 'closed'">
            <!-- DOWNLOAD TITLE -->
            <div class="download-title">
                <span (click)="toggleDownload()" class="close-button icon-close-elipse"></span><span>Info y descargas 1</span>
            </div>
            <!-- DOWNLOAD ITEMS -->
            <ul *ngIf="sbData">
                <li *ngFor="let p of downloadsItems; let kp = index;" [class.active]="p.selected">
                    <div (click)="goTo(p,2,kp)" id="{{p.sidebar_id}}">
                        <span>{{p.text | truncate:maxLabelLength}}</span>
                        <span class="arrow icon-arrow-right" *ngIf="p.items&& p.items.length && !p.selected"></span>
                        <span class="arrow icon-arrow-down" *ngIf="p.items&& p.items.length && p.selected"></span>
                    </div>
                    <ul *ngIf="(p.items&& p.items.length && (p.id !=='siniestros' || (p.id !=='siniestros' && claimLink)))"
                        [ngClass]="{expand:p.selected,shrink:!p.selected}">
                        <li *ngFor="let i of p.items; let ki = index;" (click)="goTo(i,2,kp,ki)"
                            [class.active]="i.selected"
                            id="{{i.sidebar_id}}">
                            <div><span>{{i.text}}</span></div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
    <!-- MENU -->
    <div class="main-side-bar-view main-side-bar-menu" [ngClass]="menuOpened?'opened':'closed'">
        <div class="index">
            <!-- MENU HEADER -->
            <ul *ngIf="!profileOpened" class="user-box-mobile">
                <li (click)="toggleProfile(false,true)">
                    <img src="assets/dsm/01-atm/avatars/avatar-default.svg" alt="">
                    <div class="text-mobile">Mi Cuenta</div>
                </li>
                <li (click)="openFaq()">
                    <a class="help-mobile"><span class="icon-question-elipse"></span></a>
                    <div class="text-mobile">Ayuda</div>
                </li>
            </ul>
            <div class="clearfix"></div>
            <!-- MENU ITEMS -->
            <ul *ngIf="sbData">
                <li *ngFor="let p of sideBarItems; let kp = index;" [class.active]="p.selected"
                    [ngClass]="'li-'+(p.origin||p.text)">
                    <div (click)="goTo(p,0,kp)" id="{{p.sidebar_id}}">
                        <span>{{p.text | truncate:maxLabelLength}}</span>
                        <span class="arrow icon-arrow-right" *ngIf="p.items&& p.items.length && !p.selected"></span>
                        <span class="arrow icon-arrow-down" *ngIf="p.items&& p.items.length && p.selected"></span>
                    </div>
                    <ul *ngIf="(p.items&& p.items.length && (p.id !=='siniestros' || (p.id !=='siniestros' && claimLink)))"
                        [ngClass]="{expand:p.selected,shrink:!p.selected}">
                        <li *ngFor="let i of p.items; let ki = index;" (click)="goTo(i,0,kp,ki)"
                            [class.active]="i.selected"
                            id="{{i.sidebar_id}}">
                            <div><span>{{i.text}}</span></div>
                        </li>
                    </ul>
                </li>
                <li>
                    <div (click)="toggleDownload(false,true)">
                        <span>Info y descargas</span>
                        <span class="arrow icon-arrow-right"></span>
                    </div>

                </li>
            </ul>
            <!-- MENU LOGOUT -->
            <div class="logOut" (click)="logOut()">
                <span>Cerrar sesión</span>
            </div>
        </div>
    </div>
</div>
